<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12" sm="4" md="4" lg="4" xl="4">
        <!-- 検索用のテキスト入力 -->
        <v-text-field
          v-model="titleFilterValue"
          label="ﾀｲﾄﾙ検索"
          placeholder="ﾀｲﾄﾙ検索"
          outlined
          dense
          clearable
          hide-details="auto"
          background-color="white"
        ></v-text-field>
      </v-col>
      <v-col cols="6" sm="2" md="2" lg="2" xl="2">
        <v-switch 
          v-model="viewFavoriteOnly"
          dense
          class="mt-1"
          label="お気に入りのみ"
          hide-details="auto"
        />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="request"
          :items-per-page.sync="parPageRequest"
          :footer-props="{'items-per-page-options': [10, 20, 30, 50, 100, -1]}"
          dense
          disable-sort
          @click:row="onClickRequestDetails"
          :item-class="rowStyleRequest"
          :loading="isRequestsLoding" loading-text="読込中"
          ref="request"
        >
          <!-- 依頼日と依頼者 -->
          <template #[`item.openDateAndPostUser`]="{ item }">
            <v-row dense><v-col cols="12" justify="center">{{ item.openDate }}</v-col></v-row>
            <v-row dense><v-col cols="12" justify="center">{{ item.postUser }}</v-col></v-row>
          </template>
          <!-- お気に入り -->
          <template #[`item.favoriteFlg`]="{ item }">
            <v-btn icon v-if="item.favoriteFlg" :disable="true"><v-icon color="orange">mdi-star</v-icon></v-btn>
            <v-btn icon v-if="!item.favoriteFlg" :disable="true"><v-icon>mdi-star-outline</v-icon></v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-btn fixed fab bottom color="secondary" @click="reload" style="bottom: 50px">
      <v-icon color="white">mdi-refresh</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import { httpsCallable, getFunctions } from "firebase/functions";
import Enumerable from "linq";
export default {
  data() {
    return {
      titleFilterValue: "",
      viewFavoriteOnly: false,
      headers: [
        { text: "タイトル", value: "title", filter: this.titleFilter },
        { text: "更新日時/更新者", value: "openDateAndPostUser" },
        { text: "お気に入り", value: "favoriteFlg", filter: this.favoriteFilter },
      ],
      requests: [],
      isRequestsLoding: false,
    };
  },
  // 初期表示時データ読み込み
  async created() {
    await this.reload();
  },
  watch: {
  },
  methods: {
    // タイトルフィルタ
    titleFilter(value) {
      if (!this.titleFilterValue) {
        return true;
      }
      return value.toString().includes(this.titleFilterValue);
    },
    // お気に入りフィルタ
    favoriteFilter(value) {
      if (!this.viewFavoriteOnly) {
        return true;
      }
      return value;
    },
    // 保守依頼詳細
    onClickRequestDetails(item) {
      // フィルタされた配列の取得
      let items = this.$refs.request.$children[0].filteredItems;
      // 依頼IDのみ抽出
      var requestListBuff = Enumerable.from(items).select(x => { return x.requestId }).toArray();
      var requestListIndex = requestListBuff.indexOf(item.messageId);

      this.$router.push({
        name: "RequestDetails",
        params: {
          requestId: item.requestId,
          requestListBuff: requestListBuff,
          requestListIndex: requestListIndex,
        }
      });
    },
    // ページ再読込
    async reload() {
      // 保守依頼取得
      this.requests = [];

      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const schoolAidSupportLogined = httpsCallable(functions, "schoolAidSupportLogined");
      this.isRequestsLoding = true;
      await schoolAidSupportLogined({funcName:"loadTopPageRequests"}).then((requests) => {
        var ret = [];
        requests.data.list.forEach((request) => {
          var row = {
            requestId: request.requestId,
            openDate: request.openDate,
            postUser: request.postUser,
            title: request.title,
            favoriteFlg: request.favoriteFlg,
            doFlg: request.doFlg,
          };
          ret.push(row);
        });
        this.requests = ret;
        this.isRequestsLoding = false;
      });
    },
    rowStyleRequest: function (item) {
      return item.doFlg == true ? 'not-yet-style' : 'do-style'
    },
  },  
};
</script>

<style>
.do-style {
  background-color: rgb(182, 182, 182)
}
.not-yet-style {
  background-color: rgb(255, 255, 255)
}
</style>